import TypesenseInstantSearchAdapter, { SearchClient } from 'typesense-instantsearch-adapter'

import { QueryParamsType, getTypesenseNodeName, queryParams } from '@shared/util'

export const createSearchClient = (apiKey: string, queryParamsType: QueryParamsType): SearchClient => {
  const { nodes, nearestNode } = getTypesenseNodeName(process.env.NEXT_PUBLIC_TS_NODE)
  return new TypesenseInstantSearchAdapter({
    server: {
      // TODO change this when we fix the re render issue
      retryIntervalSeconds: 10,
      numRetries: 0,
      connectionTimeoutSeconds: 10,
      apiKey,
      nodes,
      nearestNode,
      cacheSearchResultsForSeconds: 1, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
    },
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    additionalSearchParameters: {
      ...queryParams[queryParamsType],
      sort_by: 'updatedAt:desc',
    },
  }).searchClient
}

export const getSearchIndexName = (siteId: string, type: 'Site' | 'CMS') =>
  `${type}-${process.env.NEXT_PUBLIC_STAGE_NAME}-${siteId}`

export const SAVED_FILTERS_LOCAL_STORAGE_KEY = 'saved_filters'
export const SAVED_CUSTOM_FILTERS_LOCAL_STORAGE_KEY = 'saved_custom_filters'
